<template>
  <div class="section--column--center">
    <div class="TwoFactorWizardstep-size-security data--center">
      <p><strong>{{ $t('TwoFactorAuth.AuthappQuestion')}}</strong></p>
      <p>{{ $t('TwoFactorAuth.AuthappDesc')}}</p>
      <p><strong>{{ $t('TwoFactorAuth.AuthappRecomendApps')}}</strong></p>
      <div class="flex__separate05">
        <ul style="column-count: 2">
          <li><img src="../../assets/img/2fa_google-authenticator-3.svg"/><span>Google Authenticator</span></li>
          <li><img src="../../assets/img/2fa_microsoft-authenticator.svg"/><span>Microsoft Authenticator</span></li>
          <li><img src="../../assets/img/2fa_authy.svg"/><span>Authy</span></li>
          <li><img src="../../assets/img/2fa_last_pass.png"/><span>Last Pass</span></li>
          <li><img src="../../assets/img/2fa_duo_mobile.png"/><span>Duo Mobile</span></li>
        </ul>
      </div>
    </div>
    <div class="flex__separate05">
      <button @click="toBack"
              class="btn btn-primary p-x-2 border__rounded btn-2fa">{{ $t('wizard.previous')}}
      </button>
      <button @click="toContinue"
              class="btn btn-primary p-x-2 border__rounded btn-2fa">{{ $t('wizard.next')}}
      </button>
    </div>
  </div>

</template>

<script lang="ts">
import {computed, defineComponent, ref} from "vue";
import {AuthenticatorValidationStatus} from "@/types/autenticationresult";
import TwoFactorAuthenticationAPPService from "@/services/TwoFactorAuth/TwoFactorAuthenticationAPP.service";
import {useStore} from "vuex";

export default defineComponent({
  name: 'authenticatorapp2fa',
  components: {
  },
  setup() {

    const store = useStore();
    const toContinue = () => {
      TwoFactorAuthenticationAPPService.setTwoFactorAuthenticationProcessWizard(true, store);
    }

    const toBack = () => {
      TwoFactorAuthenticationAPPService.setTwoFactorAuthenticationProcessWizard(false, store);
    }
    //
    return {
      toContinue,
      toBack
    }
  }
});

</script>


<style scoped>
ul > li {
  list-style: none;
  padding-bottom: 0.5rem;
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

ul > li > img {
  height: 10%;
  width: 10%;
}


</style>
